<template>
  <bi-cohorts
    :entities="entities"
    :affiliates="affiliates"
    :report="report"
    :report-settings="reportSettings"
    :is-loading="isLoading"
    @request-affiliates="loadAffiliates"
    @request-report="onRequestReport"
  />
</template>

<script>
import { API } from '@/utils/api'
import BiCohorts from '../components/BiCohorts.vue';
const ENTITY_LIST = '/users/entity_list.json';
const AFFILIATE_LIST = '/$v/affiliate/list.json';
const COHORT_ANALYSIS = '/$v/reports/cohort_analysis.json'

export default {
  components: {
    BiCohorts
  },
  data() {
    return {
      isLoading: false,
      isLoadingAffiliates: false,
      entities: [],
      affiliates: [],
      report: null,
      reportSettings: null
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.isLoading = true

      return Promise.all([
        this.loadEntities()
      ]).finally(() => {
        this.isLoading = false
      })
    },
    loadEntities () {
      return API.call(ENTITY_LIST, { with_base: 1 }).then(r => this.entities = r.data)
    },
    loadAffiliates (entityId) {
      this.isLoadingAffiliates = true;
      return API.call(AFFILIATE_LIST, {}, null, entityId).then(resp => {
        this.affiliates = resp.data
      }).finally(() => this.isLoadingAffiliates = false)
    },
    onRequestReport(params) {
      this.isLoading = true
      return API.call(COHORT_ANALYSIS, params)
            .then(r => this.report = r.data, this.reportSettings = params)
            .finally(() => this.isLoading = false)
    }
  }
}
</script>
